import { useEffect, useRef, type ReactNode } from 'react';

/**
 * Quais bordas de uma lista com rolagem escondem conteúdo: a de cima depois de rolar para baixo,
 * a de baixo enquanto ainda há o que rolar. Meio pixel de folga para o arredondamento do zoom.
 */
export function scrollEdges(
  scrollTop: number,
  clientHeight: number,
  scrollHeight: number,
): { top: boolean; bottom: boolean } {
  return { top: scrollTop > 0.5, bottom: scrollTop + clientHeight < scrollHeight - 0.5 };
}

/**
 * A lista do menu (ADR 0071): esmaece a borda só quando há conteúdo escondido daquele lado
 * (marcas `data-fade-top` e `data-fade-bottom`, lidas pelo styles.css). Sem nada para rolar, o
 * primeiro e o último item aparecem inteiros.
 */
export function NavScroll({ className, children }: { className: string; children: ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const update = () => {
      const e = scrollEdges(el.scrollTop, el.clientHeight, el.scrollHeight);
      el.toggleAttribute('data-fade-top', e.top);
      el.toggleAttribute('data-fade-bottom', e.bottom);
    };
    update();
    el.addEventListener('scroll', update, { passive: true });
    const ro = new ResizeObserver(update);
    ro.observe(el);
    for (const child of Array.from(el.children)) ro.observe(child);
    return () => {
      el.removeEventListener('scroll', update);
      ro.disconnect();
    };
  }, []);
  return (
    <div ref={ref} className={`ui-nav-scroll ${className}`}>
      {children}
    </div>
  );
}
